import { Routes, Route } from 'libs/router'
import './i18n'
import { DashboardIndex } from 'features/dashboard'
import { PreventUser, PersistLogin } from 'shared/components'
import { useFetchStoreData } from 'shared/hooks'
import DashboardLayout from 'layouts/Dashboard/Dashboard'
import { ErrorPage } from 'features/404'
import { FloorMap } from 'features/floorMap'
import { LoginIndex, PasswordReset } from 'features/auth'
import { ProfileIndex, ChangeProfilePassword } from 'features/profile'
import { SettingsIndex } from 'features/settings'
import {
	BookingIndex,
	BookingAdd,
	BookingCalendar,
	BookingHistory,
	BookingEdit
} from 'features/bookings'
import { ProductIndex, ProductAdd, ProductEdit, ProductHistory } from './features/products'
import { SaleIndex, SaleEdit, SaleHistory } from 'features/sales'
import { PayoutIndex, PayoutEdit, PayoutHistory } from 'features/payouts'
import { TagIndex, TagHistory } from 'features/tags'
import { OpeningHourIndex, OpeningHourEdit } from 'features/openingHours'
import { CategoryIndex, CategoryHistory } from 'features/categories'
import { FabricIndex } from 'features/fabrics'
import { ConditionIndex } from 'features/conditions'
import { GenderIndex } from 'features/genders'
import { TypeIndex } from 'features/types'
import { CouponIndex, CouponAdd, CouponEdit, CouponHistory } from 'features/coupons'
import { AreaIndex, AreaEdit, AreaAdd, AreaHistory } from 'features/areas'
import { AreaTypeIndex, AreaTypeEdit, AreaTypeAdd, AreaTypeHistory } from 'features/areaTypes'
import { RentalIndex, RentalAdd, RentalEdit, RentalHistory } from 'features/rentals'
import {
	UserIndex,
	UserAdd,
	UserEdit,
	UserHistory,
	PasswordResetToken,
	ChangePassword
} from 'features/users'
import { routes } from 'config/routes'

function App() {
	useFetchStoreData()

	return (
		<>
			<Routes>
				{/* public routes */}
				<Route path={routes.login} element={<LoginIndex />} />
				<Route path={routes.passwordReset} element={<PasswordReset />} />
				<Route path={routes.passwordResetContinue} element={<PasswordResetToken />} />

				{/* private routes */}
				<Route element={<PersistLogin />}>
					<Route element={<DashboardLayout />}>
						<Route path={routes.dashboard} element={<DashboardIndex />} />
						<Route path={routes.productIndex} element={<ProductIndex />} />
						<Route path={routes.productAdd} element={<ProductAdd />} />
						<Route path={routes.productHistory()} element={<ProductHistory />} />
						<Route path={routes.productEdit()} element={<ProductEdit />} />

						<Route path={routes.saleIndex} element={<SaleIndex />} />
						<Route path={routes.saleHistory()} element={<SaleHistory />} />
						<Route path={routes.saleEdit()} element={<SaleEdit />} />

						<Route path={routes.bookingIndex} element={<BookingIndex />} />
						<Route path={routes.bookingCalendar} element={<BookingCalendar />} />
						<Route path={routes.bookingAdd} element={<BookingAdd />} />
						<Route path={routes.bookingEdit()} element={<BookingEdit />} />
						<Route path={routes.bookingHistory()} element={<BookingHistory />} />

						<Route path={routes.payoutIndex} element={<PayoutIndex />} />
						<Route path={routes.payoutEdit()} element={<PayoutEdit />} />
						<Route path={routes.payoutHistory()} element={<PayoutHistory />} />

						<Route path={routes.profileIndex} element={<ProfileIndex />} />
						<Route path={routes.profilePasswordChange} element={<ChangeProfilePassword />} />

						<Route element={<PreventUser />}>
							<Route path={routes.areaAdd} element={<AreaAdd />} />
							<Route path={routes.areaIndex} element={<AreaIndex />} />
							<Route path={routes.areaHistory()} element={<AreaHistory />} />
							<Route path={routes.areaEdit()} element={<AreaEdit />} />

							<Route path={routes.floorMapIndex} element={<FloorMap />} />

							<Route path={routes.categoryIndex} element={<CategoryIndex />} />
							<Route path={routes.categoryHistory()} element={<CategoryHistory />} />

							<Route path={routes.fabricIndex} element={<FabricIndex />} />

							<Route path={routes.conditionIndex} element={<ConditionIndex />} />

							<Route path={routes.genderIndex} element={<GenderIndex />} />

							<Route path={routes.typeIndex} element={<TypeIndex />} />

							<Route path={routes.couponIndex} element={<CouponIndex />} />
							<Route path={routes.couponAdd} element={<CouponAdd />} />
							<Route path={routes.couponHistory()} element={<CouponHistory />} />
							<Route path={routes.couponEdit()} element={<CouponEdit />} />

							<Route path={routes.tagIndex} element={<TagIndex />} />
							<Route path={routes.tagHistory()} element={<TagHistory />} />

							<Route path={routes.areaTypeIndex} element={<AreaTypeIndex />} />
							<Route path={routes.areaTypeAdd} element={<AreaTypeAdd />} />
							<Route path={routes.areaTypeHistory()} element={<AreaTypeHistory />} />
							<Route path={routes.areaTypeEdit()} element={<AreaTypeEdit />} />

							<Route path={routes.rentalIndex} element={<RentalIndex />} />
							<Route path={routes.rentalAdd} element={<RentalAdd />} />
							<Route path={routes.rentalHistory()} element={<RentalHistory />} />
							<Route path={routes.rentalEdit()} element={<RentalEdit />} />

							<Route path={routes.userIndex} element={<UserIndex />} />
							<Route path={routes.userAdd} element={<UserAdd />} />
							<Route path={routes.userEdit()} element={<UserEdit />} />
							<Route path={routes.userChangePassword()} element={<ChangePassword />} />
							<Route path={routes.userHistory()} element={<UserHistory />} />

							<Route path={routes.openingHourIndex} element={<OpeningHourIndex />} />
							<Route path={routes.openingHourEdit()} element={<OpeningHourEdit />} />

							<Route path={routes.settingsIndex} element={<SettingsIndex />} />
						</Route>
					</Route>
				</Route>

				{/* error page */}
				<Route path="/*" element={<ErrorPage />} />
			</Routes>
		</>
	)
}

export default App
